export const addEventListenerLive = (eventType, elementQuerySelector, cb, rootElement = null) => {
    let element = rootElement ? rootElement : document;
    element.addEventListener(eventType, (event) => {
        let qs = document.querySelectorAll(elementQuerySelector);
        if (qs) {
            var element = event.target, index = -1;
            while (element && ((index = Array.prototype.indexOf.call(qs, element)) === -1)) {
                element = element.parentElement;
            }
            if (index > -1) {
                cb.call(element, event);
            }
        }
    });
};
export const onHover = (el, cbOver, cbLeave) => {
    el.addEventListener('mouseenter', cbOver);
    el.addEventListener('mouseleave', cbLeave);
};
export const addEventListeners = (el, events, callback) => {
    events.forEach(event => el.addEventListener(event, callback));
};
